import { gql } from '@apollo/client';

export const updateUserQuery = gql`
  mutation UpdateUser($input: UpdateUserInput!) {
    updateUser(input: $input) {
      id
      username
      email
      avatar
      groupName
      joinDate
      status
      phoneNumber
      point
      __typename
    }
  }
`;
